<template>
    <section class="batch-costs">
        <button type="button" class="create-cost-button" @click="createCost()">New Cost <svg style="width:24px;height:24px" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" />
</svg></button>
        
        <datalist id="cost-types">
            <option v-for="type in cost_types" :key="type" :value="type">{{type}}</option>
        </datalist>

        <article v-for="cost in costs" :key="cost.uuid" :class="{saving: cost._saving, saved: cost._saved, deleting: cost._deleting}">
            <nav>
                <p v-if="cost._saving">Saving</p>
                <p v-else-if="cost._saved">Saved</p>
                <p v-else-if="cost._deleting">Deleting</p>
                <p v-else-if="cost.last_updated_at">{{new Date(cost.last_updated_at).toLocaleString()}}</p>
                <p v-else>New Cost</p>
                <button type="button" class="delete-button" @click="cost._delete = true">
                    <svg style="width:2em;height:2em" viewBox="0 0 24 24">
                        <path fill="currentColor" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z" />
                    </svg>
                </button>
            </nav>
            <fieldset>
                <label for="cost-type">Type of Cost</label>
                <input id="cost-type" type="text" list="cost-types" autocomplete="off" @input="updateAutoComplete($event.target.value)" @change="saveCost(cost)" v-model="cost.type">
            </fieldset>
            <fieldset>
                <label for="cost-amount">Amount</label>
                <input id="cost-amount" type="number" step="0.01" v-model="cost.amount" @change="saveCost(cost)">
            </fieldset>
            <!-- <fieldset>
                <div class="grow-wrap" :data-replicated-value="cost.content">
                    <textarea placeholder="Click here to enter your cost" v-model="cost.content" @change="saveCost(cost)"></textarea>
                </div>
            </fieldset> -->
            <div class="delete-confirm" v-if="cost._delete">
                <p>Are you sure you want to delete this cost?</p>
                <nav>
                    <button type="button" @click="deleteCost(cost)">Yes</button>
                    <button type="button" @click="delete cost._delete">Cancel</button>
                </nav>
            </div>
            <div class="deleted" v-if="cost._deleted">
                <p>Deleted</p>
                <button type="button" @click="restoreCost(cost)">Restore cost</button>
            </div>
        </article>
    </section>

</template>

<script>
export default {
    props: {
        batch_uuid: {
            required: true
        }
    },
    data () {
        return {
            costs: [],
            cost_types: [],
            total_cost: 0
        }
    },
    watch: {
        costs: {
            deep: true,
            handler () {
                this.total_cost = this.costs.reduce((sum,cost) => parseFloat(sum) + (parseFloat(cost.amount) || 0), 0)
                console.log(this.total_cost)
                this.$emit('total_cost', this.total_cost)
            }
        }
    },
    methods: {
        async updateAutoComplete (value) {
            this.cost_types = await this.$db.autocompleteCostType(value)
            console.log(this.cost_types)
        },
        createCost () {
            this.costs.unshift({
                batch_uuid: this.batch_uuid,
                uuid: null,
                content: '',
                created_at: Date.now(),
            })
            this.editing_index = 0
        },
        async saveCost (cost) {
            cost._saving = true
            // Update cost to load the uuid for newly created costs
            const d = await this.$db.saveBatchCost(cost)
            cost.uuid = d.uuid
            cost.last_updated_at = d.last_updated_at
            delete cost._saving
            cost._saved = true
            setTimeout(() => {
                delete cost._saved
            }, 2000)
        },
        async deletecost (cost) {
            delete cost._delete
            cost._deleting = true
            // Only delete costs that were actually saved
            if (cost.uuid) await this.$db.deleteBatchCost(cost.uuid)
            delete cost._deleting
            cost._deleted = true
        },
        async restorecost (cost) {
            delete cost._deleted
            this.saveCost(cost)
        }
    },
    async mounted () {
        const data = await this.$db.fetchBatchCosts(this.batch_uuid, 1, 100)
        this.costs = data.data
    }
}
</script>

<style scoped>

.batch-costs {
    display:flex;
    flex-direction: column;
    gap:1rem;
    margin-top:1rem;
}

article {
    position:relative;
}
article::after {
    /* border-radius:0.5rem; */
}

article>nav>p {
    font-style: italic;
    font-size:0.8em;
}

.create-cost-button {
    align-self: flex-start;
}

.delete-button {
    padding:0 0.5em;
    background-color:lightcoral;
}

/* article.saving::after {
    content: 'SAVING';
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    font-size:2em;
    display: flex;
    align-items: center;
    justify-content: center;
    
    background: linear-gradient(266deg, #40a543cc, #9ddd00cc);
    background-size: 400% 400%;

    animation: WorkingIndicator 1s infinite;
}

article.saved::after {
    content: 'SAVED';
    background-color:rgba(135, 207, 235, 0.246);
    border:solid 2px dodgerblue;
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    font-size:2em;
    display: flex;
    align-items: center;
    justify-content: center;
}

article.deleting::after {
    content: 'DELETING';
    background-color:lightcoral;
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    display: flex;
    align-items: center;
    justify-content: center;
} */

.delete-confirm {
    padding:1rem;
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    background-color:lightcoral;
}

.deleted {
    padding:1rem;
    position:absolute;
    top:0;
    right:0;
    bottom:0;
    left:0;
    background-color:lightcoral;
}
</style>